import React from "react";
import PropTypes from "prop-types";
import OsmosisDataSkeleton from "./OsmosisDataSkeleton";

const formatCap = (capNumber) => {
  return capNumber.toLocaleString("en-US", { maximumFractionDigits: 0 });
};

const StatCard = ({ icon, title, value }) => (
  <div className="p-4 bg-white shadow rounded-lg flex items-center justify-center">
    <div>
      <h3 className="text-lg sm:text-xl font-semibold text-gray-600 flex items-center">
        <img src={icon} alt={title} className="w-6 h-6 mr-2" />
        {title}
      </h3>
      <p className="text-xl sm:text-2xl font-bold text-gray-800">{value}</p>
    </div>
  </div>
);

const LibraLiquidity = ({ osmosisPoolData, buyOrders }) => {
  if (!buyOrders) {
    return <OsmosisDataSkeleton />;
  }

  const olswapLiquidity = buyOrders.reduce((acc, order) => {
    return acc + order.amount * order.price;
  }, 0);

  if (!osmosisPoolData) {
    return <OsmosisDataSkeleton />;
  }

  return (
    <div className="mb-8">
      <h3 className="text-2xl font-semibold mb-4">Libra Liquidity</h3>
      <div className="mb-8 grid grid-cols-2 sm:grid-cols-3 gap-4">
        <StatCard
          icon="/icons/osmosis.svg"
          title="Osmosis"
          value={`$${formatCap(osmosisPoolData.liquidity)}`}
        />
        <StatCard
          icon="/icons/olswap.png"
          title="0Lswap"
          value={`$${formatCap(olswapLiquidity)}`}
        />
        <StatCard
          icon="/icons/libra.png"
          title="Total"
          value={`$${formatCap(osmosisPoolData.liquidity + olswapLiquidity)}`}
        />
      </div>
    </div>
  );
};

LibraLiquidity.propTypes = {
  osmosisPoolData: PropTypes.object,
  buyOrders: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
    })
  ),
};

export default LibraLiquidity;
